// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-text ul {
  list-style-type: none;
  padding-left: 0;
}

.card-text li {
  list-style-type: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/participant/participant_study_list/participant_study_list.component.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".card-text ul {\r\n  list-style-type: none;\r\n  padding-left: 0;\r\n}\r\n\r\n.card-text li {\r\n  list-style-type: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
